// extracted by mini-css-extract-plugin
export default {"searchResults":"SearchResults_searchResults__y7Pni","image":"SearchResults_image__WOS0q","errorMessage":"SearchResults_errorMessage__lGJ5U"};